export const ServiceID = {
  RootStore: Symbol.for("RootStore"),
  QueryClientFactory: Symbol.for("QueryClientFactory"),
  QueryClient: Symbol.for("QueryClient"),
  AuthStore: Symbol.for("AuthStore"),
  WorkspaceStore: Symbol.for("WorkspaceStore"),
  SubscriptionStore: Symbol.for("SubscriptionStore"),
};
